module.exports = __webpack_public_path__ + "static/media/podium-1st.4aacdfee.png";